/** @jsxImportSource @emotion/react */

import React from 'react';
import PageTemplate from '@page/iyagigo/page-template';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import { useNavigate } from 'react-router-dom';
import ApplicationMetadata from '@component/iyagigo/hub/application-metadata';

const ApplicationMetadataPage: React.FC<any> = () => {
  const navigate = useNavigate();

  return (
    <PageTemplate
      title='앱 정보'
      mode={'back'}
      handleNavigationClick={() => navigate(IYAGIGO_PATH.HUB_HOME_PATH)}>
      <ApplicationMetadata />
    </PageTemplate>
  );
};

export default ApplicationMetadataPage;
